import React from "react";
import styled from "styled-components";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";

const Customstyle = styled.div`
  padding: 15px;
  .searchbar-style {
    width: 200px;
    border-radius: 12px;
  }
  .category-count-search {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .total {
    color: #5f6d8c;
    font-size: 16px;
    font-weight: 600;
    width: 60px;
    height: 19px;
    margin-left: 5px;
  }
`;

function SmsLog() {
  const dataSource = [
    {
      key: "1",
      addedon: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      senton: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      message:
        "All items have been delivered as scheduled. Please let us know if there is anything else we can assist you with.",
      mobilenumber: "9876543210 ",
      error: "---",
      attempts: "1",
    },
    {
      key: "2",
      addedon: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      senton: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      message:
        "All items have been delivered as scheduled. Please let us know if there is anything else we can assist you with.",
      mobilenumber: "9876543210 ",
      error: "---",
      attempts: "1",
    },
    {
      key: "3",
      addedon: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      senton: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      message:
        "All items have been delivered as scheduled. Please let us know if there is anything else we can assist you with.",
      mobilenumber: "9876543210 ",
      error: "---",
      attempts: "1",
    },
    {
      key: "4",
      addedon: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      senton: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      message:
        "All items have been delivered as scheduled. Please let us know if there is anything else we can assist you with.",
      mobilenumber: "9876543210 ",
      error: "---",
      attempts: "1",
    },
    {
      key: "5",
      addedon: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      senton: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      message:
        "All items have been delivered as scheduled. Please let us know if there is anything else we can assist you with.",
      mobilenumber: "9876543210 ",
      error: "---",
      attempts: "1",
    },
    {
      key: "6",
      addedon: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      senton: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      message:
        "All items have been delivered as scheduled. Please let us know if there is anything else we can assist you with.",
      mobilenumber: "9876543210 ",
      error: "---",
      attempts: "1",
    },
    {
      key: "7",
      addedon: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      senton: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      message:
        "All items have been delivered as scheduled. Please let us know if there is anything else we can assist you with.",
      mobilenumber: "9876543210 ",
      error: "---",
      attempts: "1",
    },
    {
      key: "8",
      addedon: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      senton: (
        <>
          <p>
            24th Aug 2024;
            <br />
            07:10 AM
          </p>
        </>
      ),
      message:
        "All items have been delivered as scheduled. Please let us know if there is anything else we can assist you with.",
      mobilenumber: "9876543210 ",
      error: "---",
      attempts: "1",
    },
  ];

  const columns = [
    {
      title: "Added on",
      dataIndex: "addedon",
      key: "addedon",
      width: "12%",
    },
    {
      title: "Sent on",
      dataIndex: "senton",
      key: "senton",
      width: "12%",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      width: "40%",
      render: (text) => (
        <div
          style={{
            maxWidth: "380px",
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "break-word",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Mobile Number",
      dataIndex: "mobilenumber",
      key: "mobilenumber",
      width: "15%",
    },
    {
      title: "Error",
      dataIndex: "error",
      key: "error",
      width: "10%",
    },
    {
      title: "Attempts",
      dataIndex: "attempts",
      key: "attempts",
      width: "12%",
    },
  ];
  return (
    <Customstyle>
      <div className="d-flex justify-content-between align-items-center">
        <div className="total">{dataSource.length} SMS</div>
      </div>
      <StyledTable
        className="mt-4"
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        style={{
          cursor: "default",
        }}
      />
    </Customstyle>
  );
}

export default SmsLog;
